import { useRef, useEffect, useCallback } from "react";

function useClickOutside<T extends HTMLElement = HTMLDivElement>(
  handler: () => void,
  enabled: boolean = true,
  extraRef?: React.RefObject<HTMLElement>
) {
  const ref = useRef<T>(null);

  const stableHandler = useCallback(handler, [handler]);
  
  useEffect(() => {
    // CRITICAL FIX: Return early if not enabled
    if (!enabled) return;

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;

      // Check if click is outside both the dropdown AND the button
      if (
        ref.current &&
        !ref.current.contains(target) &&
        (!extraRef || !extraRef.current?.contains(target))
      ) {
        stableHandler();
      }
    };

    // Add a small delay to prevent immediate closing when opening
    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0); // Changed from 100ms to 0ms - the setTimeout is just to defer to next tick

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stableHandler, enabled, extraRef]); 
  
  return ref;
}

export default useClickOutside;